import clsx from 'clsx';

type Props = {
  label: string;
  checked: boolean;
  onChange: () => void;
  id: string;
};

export const LabeledCheckbox: React.FC<Props> = ({
  label,
  checked,
  onChange,
  id,
}) => {
  return (
    <label htmlFor={id} className="flex gap-3 items-center text-sm">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="h-3 w-3"
        id={id}
      />
      <span
        className={clsx(!checked ? 'text-black-50 dark:text-white-50' : '')}
      >
        {label}
      </span>
    </label>
  );
};
